document.addEventListener('DOMContentLoaded', () => {
    new IllCollection();
});

class IllCollection {
    constructor() {
        this.init();
    }

    init() {
        this.bindEvents();
        this.initSticky();
        this.updateTopActiveState();
        this.initExploreMore();
    }

    bindEvents() {
        // Global Delegation for Clicks (Pills)
        document.addEventListener('click', (e) => {
            // IllToChill Mobile Split Tab Switching (Delegated)
            const splitTab = e.target.closest('.ill-split-tab');
            if (splitTab) {
                const container = splitTab.closest('.ill-mobile-split-layout');
                if (container) {
                    // Deactivate all
                    container.querySelectorAll('.ill-split-tab').forEach(t => t.classList.remove('is-active'));
                    container.querySelectorAll('.ill-split-content').forEach(c => c.classList.remove('is-active'));

                    // Activate clicked
                    splitTab.classList.add('is-active');
                    const targetId = splitTab.dataset.target;
                    const targetContent = container.querySelector('#' + targetId);
                    if (targetContent) targetContent.classList.add('is-active');

                    // Store active tab in memory to persist after AJAX
                    this.activeSplitTabId = targetId;
                }
                return;
            }

            // Intercept Clear Button
            const clearLink = e.target.closest('.ill-pill-clear') || e.target.closest('.ill-drawer-clear');
            if (clearLink && (clearLink.tagName === 'A' || clearLink.tagName === 'BUTTON')) {
                if (clearLink.tagName === 'A') {
                    e.preventDefault();
                    // Clear logic
                    const url = new URL(clearLink.href, window.location.origin);
                    this.filter(url.searchParams.toString());
                    return;
                }
            }

            // Intercept Type Nav Items (Secondary Navbar)
            const navItem = e.target.closest('.ill-type-nav-item');
            if (navItem && navItem.tagName === 'A') {
                e.preventDefault();

                // Instant UI Update: Switch active class immediately
                const container = navItem.closest('.ill-filters-top');
                if (container) {
                    container.querySelectorAll('.ill-type-nav-item').forEach(el => el.classList.remove('is-active'));
                    navItem.classList.add('is-active');
                }

                const url = new URL(navItem.href, window.location.origin);
                this.filter(url.searchParams.toString());
                return;
            }

            const pill = e.target.closest('.ill-filter-pill');
            const dropdown = e.target.closest('.ill-filter-dropdown');
            const mobileTrigger = e.target.closest('.ill-mobile-trigger');
            const closeDrawer = e.target.closest('.ill-drawer-close') || e.target.closest('.ill-drawer-apply');

            if (pill && !dropdown) {
                // Prevent closing if clicking input/label which propagates to pill
                if (['INPUT', 'LABEL', 'A'].includes(e.target.tagName)) return;
                this.togglePill(e, pill);
            } else if (!pill && !dropdown && !mobileTrigger && !e.target.closest('.ill-mobile-drawer')) {
                this.closeAllPills();
            }

            // Sidebar Accordion (Delegate)
            // Native <details> handles toggling automatically, but we might want to track state or animate.
            // Our CSS animation relies on the open attribute.
            // If we need custom behavior:
            const summary = e.target.closest('summary');
            if (summary && summary.closest('.ill-facet-group')) {
                // Native behavior works fine, but let's ensure we don't interfere
            }

            // Mobile Drawer actions
            if (mobileTrigger) {
                const d = document.querySelector('.ill-mobile-drawer');
                if (d) {
                    d.classList.add('is-open');
                    document.body.style.overflow = 'hidden';
                }
            }
            if (closeDrawer) {
                const d = document.querySelector('.ill-mobile-drawer');
                if (d) {
                    d.classList.remove('is-open');
                    document.body.style.overflow = '';
                }
            }
        });

        // Inputs (Delegate globally)
        document.body.addEventListener('change', (e) => {
            if (e.target.closest('.ill-filter-form') || e.target.closest('.ill-filter-form-top')) {
                if (e.target.matches('input')) {
                    this.inputChanged(e.target);
                }
            }
        });
    }

    initSticky() {
        window.addEventListener('scroll', () => {
            if (document.querySelector('.ill-filter-pill.is-open')) this.closeAllPills();
            this.handleSticky();
        });

        window.addEventListener('resize', () => this.handleSticky());
        // Initial call
        requestAnimationFrame(() => this.handleSticky());
    }

    handleSticky() {
        // Attempt to find a sticky header (Dawn generic or custom)
        const stickyHeader = document.querySelector('sticky-header') || document.querySelector('.shopify-section-header.sticky');
        let topOffset = 0;

        if (stickyHeader) {
            const rect = stickyHeader.getBoundingClientRect();
            // If it's visible and touching top (or near top), treat as the offset
            if (rect.bottom > 0 && rect.top <= 1) {
                topOffset = rect.bottom;
            }
        }

        const navbar = document.querySelector('.ill-filters-top-wrapper');
        if (navbar) {
            navbar.style.top = `${topOffset}px`;

            // Toggle shadow if stuck
            // If the element's top position matches the offset and we've scrolled past initial pos
            if (navbar.getBoundingClientRect().top <= topOffset + 1 && window.scrollY > 10) {
                navbar.classList.add('is-stuck');
            } else {
                navbar.classList.remove('is-stuck');
            }

            // Adjust Sidebar
            const sidebar = document.querySelector('.ill-sidebar');
            if (sidebar) {
                const navHeight = navbar.offsetHeight;
                sidebar.style.top = `${topOffset + navHeight + 20}px`;
            }
        }
    }

    togglePill(e, pill) {
        const isOpen = pill.classList.contains('is-open');
        this.closeAllPills();
        if (!isOpen) {
            pill.classList.add('is-open');
            this.positionDropdown(pill);
        }
    }

    positionDropdown(pill) {
        const dropdown = pill.querySelector('.ill-filter-dropdown');
        if (!dropdown) return;

        const rect = pill.getBoundingClientRect();
        dropdown.style.position = 'fixed';
        dropdown.style.top = `${rect.bottom + 5}px`;
        dropdown.style.left = `${rect.left}px`;
        dropdown.style.zIndex = '1001';

        // Edge detection? If off screen right?
        // Simple check:
        if (rect.left + 250 > window.innerWidth) {
            dropdown.style.left = 'auto';
            dropdown.style.right = '20px';
        }
    }

    closeAllPills() {
        document.querySelectorAll('.ill-filter-pill').forEach(p => {
            p.classList.remove('is-open');
            // Reset styles? Not strictly needed if display:none, but cleaner
            const d = p.querySelector('.ill-filter-dropdown');
            if (d) {
                d.style.position = '';
                d.style.top = '';
                d.style.left = '';
            }
        });
    }

    inputChanged(input) {
        const params = new URLSearchParams(window.location.search);
        const name = input.name;
        const value = input.value;

        if (input.type === 'checkbox') {
            if (input.checked) {
                params.append(name, value);
            } else {
                const allValues = params.getAll(name);
                params.delete(name);
                allValues.forEach(v => {
                    if (v !== value) params.append(name, v);
                });
            }
        } else {
            if (value) {
                params.set(name, value);
            } else {
                params.delete(name);
            }
        }

        params.delete('page');
        this.filter(params.toString());
    }

    filter(searchParams) {
        const url = `${window.location.pathname}?${searchParams}`;
        history.pushState(null, '', url);
        this.renderSection(url);
    }

    async renderSection(url) {
        // Abort previous pending request to prevent stale DOM overwrites
        if (this.currentFetchController) {
            this.currentFetchController.abort();
        }
        this.currentFetchController = new AbortController();
        const signal = this.currentFetchController.signal;

        const grid = document.querySelector('.ill-product-grid');
        if (grid) grid.classList.add('opacity-50');

        try {
            const res = await fetch(url, { signal });
            const text = await res.text();
            const doc = new DOMParser().parseFromString(text, 'text/html');

            // 1. Update Layout (fallback or legacy)
            const newLayout = doc.querySelector('.ill-collection-layout');
            const oldLayout = document.querySelector('.ill-collection-layout');
            if (newLayout && oldLayout) {
                // If we have a layout wrapper, we might be replacing too much. 
                // Let's rely on specific updates below.
            }

            // 2. Update Sidebar Filters (Smart Patching)
            try {
                this.updateSidebar(doc);
            } catch (err) {
                console.warn('Sidebar update failed', err);
            }

            // 3. Update Product Grid
            const newGrid = doc.querySelector('#ProductGridContainer');
            const oldGrid = document.querySelector('#ProductGridContainer');
            if (newGrid && oldGrid) {
                oldGrid.innerHTML = newGrid.innerHTML;
            }

            // 4. Update Header/Mobile Drawer parts if they exist
            const newHeader = doc.querySelector('.ill-collection-header');
            const oldHeader = document.querySelector('.ill-collection-header');
            if (newHeader && oldHeader) oldHeader.innerHTML = newHeader.innerHTML;

            const newMobile = doc.querySelector('.ill-mobile-drawer-body');
            const oldMobile = document.querySelector('.ill-mobile-drawer-body');
            if (newMobile && oldMobile) {
                oldMobile.innerHTML = newMobile.innerHTML;

                // RESTORE ACTIVE TAB
                if (this.activeSplitTabId) {
                    const container = document.querySelector('.ill-mobile-split-layout');
                    if (container) {
                        const tab = container.querySelector(`.ill-split-tab[data-target="${this.activeSplitTabId}"]`);
                        const content = container.querySelector('#' + this.activeSplitTabId);

                        if (tab && content) {
                            // Reset Defaults
                            container.querySelectorAll('.ill-split-tab').forEach(t => t.classList.remove('is-active'));
                            container.querySelectorAll('.ill-split-content').forEach(c => c.classList.remove('is-active'));

                            // Set Active
                            tab.classList.add('is-active');
                            content.classList.add('is-active');
                        }
                    }
                }
            }

            // Drawer Apply Button
            const newBtn = doc.querySelector('.ill-drawer-apply');
            const oldBtn = document.querySelector('.ill-drawer-apply');
            if (newBtn && oldBtn) oldBtn.innerHTML = newBtn.innerHTML;

            // 5. Update Top Filters (Categories: Apparel, Bags, etc.)
            const newTopFilters = doc.querySelector('.ill-filters-top-wrapper');
            const oldTopFilters = document.querySelector('.ill-filters-top-wrapper');
            if (newTopFilters && oldTopFilters) {
                oldTopFilters.innerHTML = newTopFilters.innerHTML;
            }

            // 6. Force Update Active State (Client-Side Guarantee)
            this.updateTopActiveState();

            // 7. Re-init Explore More
            this.initExploreMore();

            // Restore sticky state immediately
            this.handleSticky();

        } catch (e) {
            if (e.name === 'AbortError') return; // Ignore expected aborts
            console.error(e);
        } finally {
            // Only remove opacity if this is the LATEST request (signal not aborted)
            if (!signal.aborted && grid) grid.classList.remove('opacity-50');
        }
    }

    updateSidebar(newDoc) {
        const newFilters = newDoc.querySelector('#main-collection-filters');
        const oldFilters = document.querySelector('#main-collection-filters');
        if (!newFilters || !oldFilters) return;

        // 1. Update Header (Clear All button visibility/text)
        const newHeader = newFilters.querySelector('.ill-facets-header');
        const oldHeader = oldFilters.querySelector('.ill-facets-header');
        if (newHeader && oldHeader) {
            oldHeader.innerHTML = newHeader.innerHTML;
        }

        // 2. Structural Check: If the number of groups changed (e.g. Size hidden/shown), 
        // we might be better off reflowing appropriately or inserting missing groups.
        const newGroups = Array.from(newFilters.querySelectorAll('.ill-facet-group'));
        const oldGroups = Array.from(oldFilters.querySelectorAll('.ill-facet-group'));

        // Strategy: 
        // A. If a group exists in New but not Old -> Insert it.
        // B. If a group exists in Old but not New -> Remove it.
        // C. If exists in both -> Update content + Badge.

        // First, check deletions (Old not in New)
        oldGroups.forEach(oldGroup => {
            const label = oldGroup.querySelector('.ill-facet-summary span')?.textContent.trim();
            const match = newGroups.find(g => g.querySelector('.ill-facet-summary span')?.textContent.trim() === label);
            if (!match) {
                oldGroup.remove();
            }
        });

        // Loop through New Groups to Insert or Update
        newGroups.forEach((newGroup, index) => {
            const label = newGroup.querySelector('.ill-facet-summary span')?.textContent.trim();
            const oldGroup = Array.from(oldFilters.querySelectorAll('.ill-facet-group')).find(g => g.querySelector('.ill-facet-summary span')?.textContent.trim() === label);

            if (oldGroup) {
                // UPDATE EXISTING
                // Update Badge Count
                const oldBadge = oldGroup.querySelector('.ill-facet-badge');
                const newBadge = newGroup.querySelector('.ill-facet-badge');
                if (oldBadge && newBadge) {
                    oldBadge.textContent = newBadge.textContent;
                } else if (!oldBadge && newBadge) {
                    oldGroup.querySelector('.ill-facet-title').appendChild(newBadge.cloneNode(true));
                } else if (oldBadge && !newBadge) {
                    oldBadge.remove();
                }

                // Update Content
                const oldContent = oldGroup.querySelector('.ill-facet-content');
                const newContent = newGroup.querySelector('.ill-facet-content');
                if (oldContent && newContent) {
                    oldContent.innerHTML = newContent.innerHTML;
                }
            } else {
                // INSERT NEW (e.g. Size appearing)
                // Find insertion point based on index
                const currentGroups = Array.from(oldFilters.querySelectorAll('.ill-facet-group'));
                // If it's the first one
                if (index === 0) {
                    const list = oldFilters.querySelector('.ill-facets-list');
                    if (list) list.prepend(newGroup.cloneNode(true));
                } else {
                    // Try to insert after the previous one in the NEW list (which we know exists or was just inserted)
                    const prevNewGroup = newGroups[index - 1];
                    const prevNewUserLabel = prevNewGroup.querySelector('.ill-facet-summary span')?.textContent.trim();
                    const prevOldGroup = currentGroups.find(g => g.querySelector('.ill-facet-summary span')?.textContent.trim() === prevNewUserLabel);

                    if (prevOldGroup) {
                        prevOldGroup.after(newGroup.cloneNode(true));
                    } else {
                        // Fallback append
                        const list = oldFilters.querySelector('.ill-facets-list');
                        if (list) list.appendChild(newGroup.cloneNode(true));
                    }
                }
            }
        });
    }

    updateTopActiveState() {
        const params = new URLSearchParams(window.location.search);
        let currentType = params.get('filter.p.product_type');

        const normalize = (str) => {
            if (!str) return '';
            const txt = document.createElement('textarea');
            txt.innerHTML = str;
            return txt.value.trim();
        };

        const normalizedCurrent = normalize(currentType);
        const links = document.querySelectorAll('.ill-type-nav-item');
        let matched = false;

        links.forEach(link => {
            link.classList.remove('is-active');
            const val = normalize(link.dataset.value);
            if (normalizedCurrent && (val === normalizedCurrent || link.dataset.value === currentType)) {
                link.classList.add('is-active');
                matched = true;
            }
        });

        if (!currentType) {
            const allLink = document.querySelector('.ill-type-nav-item[data-value="All"]');
            if (allLink) {
                allLink.classList.add('is-active');
                matched = true;
            }
        }
    }

    initExploreMore() {
        const products = document.querySelectorAll('.ill-product-item');
        const btnContainer = document.querySelector('.ill-explore-more-container');
        const btn = document.querySelector('.ill-explore-more-btn');
        const fallbackPagination = document.querySelector('.ill-pagination-fallback');

        // If no products (empty state), hide everything
        if (products.length === 0) {
            if (btnContainer) btnContainer.style.display = 'none';
            if (fallbackPagination) fallbackPagination.style.display = 'none';
            return;
        }

        // Configuration
        const INITIAL_VISIBLE = 16; // 4 rows x 4 cols
        const STEP = 8; // Reveal 2 rows

        let currentVisible = 0;

        // Reset visibility
        products.forEach((p, index) => {
            if (index < INITIAL_VISIBLE) {
                p.classList.remove('force-hidden');
                p.style.display = '';
                currentVisible++;
            } else {
                p.classList.add('force-hidden');
                p.style.display = 'none';
            }
        });

        // Show/Hide Button
        if (products.length > INITIAL_VISIBLE) {
            if (btnContainer) btnContainer.style.display = 'block';

            if (btn) {
                btn.onclick = (e) => {
                    e.preventDefault();
                    let revealedCount = 0;
                    const hidden = document.querySelectorAll('.ill-product-item.force-hidden');

                    // Target strictly 8 items (STEP)
                    for (let i = 0; i < hidden.length; i++) {
                        if (i < STEP) {
                            const p = hidden[i];
                            p.classList.remove('force-hidden');
                            p.style.display = '';
                            p.style.opacity = '0';
                            requestAnimationFrame(() => {
                                p.style.transition = 'opacity 0.5s ease';
                                p.style.opacity = '1';
                            });
                            revealedCount++;
                        } else {
                            break; // Stop after 8
                        }
                    }

                    // Check remaining hidden *after* this reveal
                    const remainingHidden = document.querySelectorAll('.ill-product-item.force-hidden');

                    if (remainingHidden.length === 0) {
                        // We just revealed the rest -> REMOVE DOM
                        if (btnContainer) btnContainer.remove();

                        // Show fallback pagination implementation if needed
                        if (fallbackPagination) fallbackPagination.style.display = 'block';
                    }
                };
            }

        } else {
            // All products fit in initial view
            if (btnContainer) btnContainer.remove(); // Remove if not needed
            if (fallbackPagination) fallbackPagination.style.display = 'block';
        }
    }
}
